import React from 'react';
import { filter, chain } from 'lodash';
import enhance from './Deals.enhancer';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { dealStatuses } from '../../constants';
import DealTable from './DealTable';
import DealForm from './new-deal/DealForm';
import ViewDeal from './view-deal/ViewDeal';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import Dialog from '@material-ui/core/Dialog';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';
import CircularProgress from '@material-ui/core/CircularProgress';
import ViewProposal from './proposals/ViewProposal';
import EscrowFunds from './escrow-funds/EscrowFunds';

const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));

class Deals extends React.Component {
  constructor() {
    super();

    this.viewStates = {
      ALL: 'ALL',
      ACTIVE: 'ACTIVE',
      PENDING: 'PROPOSAL_SENT',
      COMPLETE: 'COMPLETE',
      CONTENT_REVIEW: 'CONTENT_REVIEW',
      ARCHIVED: 'ARCHIVED'
    };

    this.initialState = {
      index: 0,
      dealsList: [],
      tableRows: [],
      filteredRows: [],
      proposeDealActive: false,
      viewDealActive: false,
      viewStates: [
        {
          key: this.viewStates.ALL,
          value: 'All Deals'
        },
        {
          key: this.viewStates.ACTIVE,
          value: 'Active'
        },
        {
          key: this.viewStates.PENDING,
          value: 'Pending'
        },
        {
          key: this.viewStates.COMPLETE,
          value: 'Complete'
        },
        {
          key: this.viewStates.ARCHIVED,
          value: 'Archived'
        }
      ],
      tableView: this.viewStates.ALL,
      currentDeal: {},
      rowsLoaded: false,
      campaignsLoaded: false,
      hasCampaign: false,
      isCompleteContentModalOpen: false,
      dealToComplete: {},
      currentDealProposal: {},
      viewPropsalIsOpen: false
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillMount() {
    if (this.props.dealList) {
      if (this.props.dealList.length) {
        this.loadData(this.props.dealList);
      } else {
        this.setState({
          tableRows: [],
          filteredRows: [],
          rowsLoaded: true
        });
      }
    }
    if (this.props.campaignsLoaded) {
      this.setState({
        campaignsLoaded: true
      });
      if (this.props.campaignsCount) {
        this.setState({
          hasCampaign: true
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealList) {
      if (nextProps.dealList.length) {
        this.loadData(nextProps.dealList);
      } else {
        this.setState({
          tableRows: [],
          filteredRows: [],
          rowsLoaded: true
        });
      }
    }
    if (this.props.campaignsLoaded) {
      this.setState({
        campaignsLoaded: true
      });
      if (this.props.campaignsCount) {
        this.setState({
          hasCampaign: true
        });
      }
    }
  }

  loadData(dealList) {
    let dealsFilterQuery = chain(dealList);

    dealsFilterQuery = dealsFilterQuery.filter(
      deal =>
        deal.status !== dealStatuses.OFFER &&
        deal.status !== dealStatuses.MATCH_REJECTED &&
        deal.status !== dealStatuses.UNMATCHED &&
        deal.status !== dealStatuses.PROPOSAL_REJECTED
    );

    if (this.props.campaignId) {
      dealsFilterQuery = dealsFilterQuery.filter(
        deal => deal.campaignId === this.props.campaignId
      );
    }

    const offeredDeals = dealsFilterQuery.value();

    let requests = offeredDeals.map(deal => {
      const userId = this.props.isCompany ? deal.influencerId : deal.companyId;
      return new Promise(resolve => {
        //get user data
        this.props.firestore
          .get({
            collection: 'users',
            doc: userId
          })
          .then(user => {
            if (user && userId) {
              const userData = user.data();
              if (userData) {
                deal.user = userData;
                deal.user.uid = user.id;
              }
            }

            //get campaign data
            this.props.firestore
              .get({
                collection: 'campaigns',
                storeAs: 'dealsCampaign',
                doc: deal.campaignId
              })
              .then(camp => {
                if (camp && deal.campaignId) {
                  const campData = camp.data();
                  if (campData) {
                    deal.campaign = campData;
                    deal.campaignId = camp.id;
                  }
                }
                resolve(deal);
              });
          });
      });
    });

    Promise.all(requests).then(deals => {
      this.setState({
        matchOffers: deals
      });
      this.filterDeals();
    });
  }

  filterDeals() {
    // const filteredOffers = filter(this.state.matchOffers, offer =>
    //   tableState === 'RECIEVED'
    //     ? offer.initiator === 'influencer'
    //     : offer.initiator === 'company'
    // );

    this.setState({
      tableRows: this.state.matchOffers,
      filteredRows: this.state.matchOffers,
      rowsLoaded: true
    });

    this.filterRowsByStatus('ALL');
  }

  createDealProposal() {
    this.props.history.push('/deals/new');
  }

  getStatusTextClass(status) {
    switch (status) {
      case dealStatuses.MATCHED:
        return this.props.classes.matchedStatus;
    }
  }

  handleBackToListClick() {
    this.setState({
      index: 0
    });
  }

  handleNextClick() {
    const newIndex = this.state.index + 1;
    this.setState({
      index: newIndex
    });
  }

  handleBackClick() {
    const newIndex = this.state.index - 1;
    this.setState({
      index: newIndex
    });
  }

  handleProposeDealClick(row) {
    const dealRecipientId = this.props.profile.isCompany
      ? row.influencerId
      : row.companyId;

    this.props.firestore
      .collection('users')
      .doc(dealRecipientId)
      .get()
      .then(recipientDoc => {
        const dealRecipient = recipientDoc.data();
        this.setState({
          proposeDealActive: true,
          viewDealActive: false,
          currentDeal: row,
          dealRecipient: { ...dealRecipient, id: recipientDoc.id }
        });
        this.handleNextClick();
      });
  }

  handleViewDealClickHandler(currentDeal) {
    this.setState({
      proposeDealActive: false,
      viewDealActive: true,
      currentDeal
    });
    this.handleNextClick();
  }

  handleUnmatchDealClick(row) {
    this.props.unmatchDealClick(row.id, this.props.auth.uid);
  }

  viewSelectChangeHandler(e) {
    const status = e.target.value;
    this.filterRowsByStatus(status);
  }

  navigateToCreateCampaign() {
    this.props.history.push(`/campaign/new`);
  }

  filterRowsByStatus(status) {
    let filteredRows = [];
    switch (status) {
      case dealStatuses.ACTIVE:
        filteredRows = filter(
          this.state.tableRows,
          row => row.status === dealStatuses.ACTIVE
        );
        break;
      case dealStatuses.COMPLETE:
        filteredRows = filter(
          this.state.tableRows,
          row =>
            row.status === dealStatuses.COMPLETE &&
            ((row.user.isCompany && !row.influencerArchived) ||
              (!row.user.isCompany && !row.companyArchived))
        );
        break;
      case dealStatuses.DEAL_ACCEPTED:
        filteredRows = filter(
          this.state.tableRows,
          row => row.status === dealStatuses.DEAL_ACCEPTED
        );
        break;
      case dealStatuses.PROPOSAL_SENT:
        filteredRows = filter(
          this.state.tableRows,
          row => row.status === dealStatuses.PROPOSAL_SENT
        );
        break;
      case dealStatuses.CONTENT_COMPLETE:
        filteredRows = filter(
          this.state.tableRows,
          row => row.status === dealStatuses.CONTENT_COMPLETE
        );
        break;
      case 'ARCHIVED':
        filteredRows = filter(
          this.state.tableRows,
          row =>
            row.status === dealStatuses.COMPLETE &&
            ((row.user.isCompany && row.influencerArchived) ||
              (!row.user.isCompany && row.companyArchived))
        );
        break;
      default:
        filteredRows = [
          ...filter(
            this.state.tableRows,
            row =>
              (row.user.isCompany && !row.influencerArchived) ||
              (!row.user.isCompany && !row.companyArchived)
          )
        ];
        break;
    }

    this.setState({
      tableView: status,
      filteredRows: filteredRows
    });
  }

  saveCurrentProposal(editedDeal) {
    this.setState({
      currentDeal: {
        ...this.state.currentDeal,
        ...editedDeal
      }
    });
  }

  viewProposalClickHandler(deal) {
    this.setState({
      currentDealProposal: deal,
      viewPropsalIsOpen: true
    });
  }

  closeViewProposal() {
    this.setState({
      currentDealProposal: {},
      viewPropsalIsOpen: false
    });
  }

  viewEscrowFundsClickHandler(deal) {
    this.props.viewEscrowFundsClick(deal);
  }

  viewSubmitDealContentFormHandler(deal) {
    this.props.viewCompleteDealFormClick(deal);
  }

  closeDrawer() {
    this.setState({
      ...this.initialState
    });
  }

  handleCloseCompleteModal() {
    this.setState({
      isCompleteContentModalOpen: false,
      dealToComplete: {}
    });
  }

  handleOpenCompleteModal(dealToComplete) {
    this.setState({
      isCompleteContentModalOpen: true,
      dealToComplete
    });
  }

  completeContent() {
    this.props.completeContentHandler(
      this.state.dealToComplete.id,
      this.state.dealToComplete.influencerId
    );
    this.closeDrawer();
    this.setState({
      ...this.initialState
    });
  }

  getStepContent(params) {
    const { key } = params;
    switch (this.state.index) {
      case 0:
        return (
          <DealTable
            key={key}
            tableRows={this.state.filteredRows}
            rowsLoaded={this.state.rowsLoaded}
            viewSelectChangeHandler={this.viewSelectChangeHandler.bind(this)}
            tableView={this.state.tableView}
            handleProposeDealClick={this.handleProposeDealClick.bind(this)}
            handleUnmatchDealClick={this.handleUnmatchDealClick.bind(this)}
            handleViewProposalClick={this.viewProposalClickHandler.bind(this)}
            handleEscrowFundsClick={this.viewEscrowFundsClickHandler.bind(this)}
            handleSubmitContentClick={this.viewSubmitDealContentFormHandler.bind(
              this
            )}
            handleViewDealClick={this.handleViewDealClickHandler.bind(this)}
            handleBackClick={this.handleBackClick.bind(this)}
            isCompany={this.props.isCompany}
            viewStates={this.state.viewStates}
            campaignsLoaded={this.state.campaignsLoaded}
            hasCampaign={this.state.hasCampaign}
            handleOpenCompleteModal={this.handleOpenCompleteModal.bind(this)}
            campaignId={this.props.campaignId}
          />
        );

      case 1:
        if (this.state.proposeDealActive) {
          return (
            <div className={this.props.classes.dealForm}>
              <DealForm
                key={key}
                handleBackClick={this.handleBackClick.bind(this)}
                handleBackToListClick={this.handleBackToListClick.bind(this)}
                currentDeal={this.state.currentDeal}
                onProposalComplete={this.handleBackToListClick}
                dealRecipient={this.state.dealRecipient}
                user={this.props.auth}
              />
            </div>
          );
        } else if (this.state.viewDealActive) {
          return (
            <ViewDeal
              key={key}
              handleBackClick={this.handleBackClick.bind(this)}
              handleBackToListClick={this.handleBackToListClick.bind(this)}
              currentDeal={this.state.currentDeal}
              user={this.props.auth}
            />
          );
        }

      default:
        return <div key={key}>out of range</div>;
    }
  }

  render() {
    const { classes } = this.props;
    const {
      isCompleteContentModalOpen,
      currentDealProposal,
      viewPropsalIsOpen
    } = this.state;

    return (
      <React.Fragment>
        <VirtualizeSwipeableViews
          style={{ width: '100%' }}
          slideCount={2}
          index={this.state.index}
          slideRenderer={this.getStepContent.bind(this)}
          disabled={true}
        />
        <Dialog
          id="payment-info-dialog"
          open={isCompleteContentModalOpen}
          onClose={this.handleCloseCompleteModal.bind(this)}
          disableAutoFocus={true}
          onBackdropClick={this.handleCloseCompleteModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="h6" align="center" justify="center">
            Complete Content
          </Typography>
          <Grid className={classes.warningMessage}>
            <WarningIcon className={classes.warningIcon} />
            <Typography display="inline" className={classes.messageText}>
              Are you sure this is ALL of the content for this deal?
            </Typography>
          </Grid>
          <Grid>
            <WarningIcon className={classes.warningIcon} />
            <Typography display="inline" className={classes.messageText}>
              You will not be able to add any more content after this.
            </Typography>
          </Grid>
          <Grid className={classes.acceptButtonContainer}>
            <Button
              color="secondary"
              onClick={() => this.handleCloseCompleteModal()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.acceptSubmitButton}
              onClick={() => this.completeContent()}
            >
              Complete
            </Button>
          </Grid>
        </Dialog>
        <ViewProposal
          handleProposeDeal={this.handleProposeDealClick.bind(this)}
          deal={currentDealProposal}
          open={viewPropsalIsOpen}
          closeClick={this.closeViewProposal.bind(this)}
          onDealAcceptComplete={() => {}}
          showButtons={true}
        />
        <EscrowFunds />
      </React.Fragment>
    );
  }
}

Deals.propTypes = {
  dealsList: PropTypes.array
};

Deals.defaultProps = {
  index: 0
};

export default enhance(Deals);



// WEBPACK FOOTER //
// ./src/components/deals/Deals.js